import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-552b63d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "screen-slide-list" }

import { computed, provide } from 'vue'
import { storeToRefs } from 'pinia'
import { useSlidesStore } from '@/store'
import { injectKeySlideScale } from '@/types/injectKey'
import { VIEWPORT_SIZE } from '@/configs/canvas'
import { SLIDE_ANIMATIONS } from '@/configs/animation'

import ScreenSlide from './ScreenSlide.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ScreenSlideList',
  props: {
    slideWidth: {},
    slideHeight: {},
    animationIndex: {},
    turnSlideToId: { type: Function },
    manualExitFullscreen: { type: Function }
  },
  setup(__props: any) {

const props = __props

const { slides, slideIndex } = storeToRefs(useSlidesStore())

const slidesWithTurningMode = computed(() => {
  return slides.value.map(slide => {
    let turningMode = slide.turningMode
    if (!turningMode) turningMode = 'slideY'
    if (turningMode === 'random') {
      const turningModeKeys = SLIDE_ANIMATIONS.filter(item => !['random', 'no'].includes(item.value)).map(item => item.value)
      turningMode = turningModeKeys[Math.floor(Math.random() * turningModeKeys.length)]
    }
    return {
      ...slide,
      turningMode,
    }
  })
})

const scale = computed(() => props.slideWidth / VIEWPORT_SIZE)
provide(injectKeySlideScale, scale)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slidesWithTurningMode.value, (slide, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass([
        'slide-item', 
        `turning-mode-${slide.turningMode}`,
        {
          'current': index === _unref(slideIndex),
          'before': index < _unref(slideIndex),
          'after': index > _unref(slideIndex),
          'hide': (index === _unref(slideIndex) - 1 || index === _unref(slideIndex) + 1) && slide.turningMode !== slidesWithTurningMode.value[_unref(slideIndex)].turningMode,
        }
      ]),
        key: slide.id
      }, [
        (Math.abs(_unref(slideIndex) - index) < 2 || slide.animations?.length)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "slide-content",
              style: _normalizeStyle({
          width: _ctx.slideWidth + 'px',
          height: _ctx.slideHeight + 'px',
        })
            }, [
              _createVNode(ScreenSlide, {
                slide: slide,
                scale: scale.value,
                animationIndex: _ctx.animationIndex,
                turnSlideToId: _ctx.turnSlideToId,
                manualExitFullscreen: _ctx.manualExitFullscreen
              }, null, 8, ["slide", "scale", "animationIndex", "turnSlideToId", "manualExitFullscreen"])
            ], 4))
          : _createCommentVNode("", true)
      ], 2))
    }), 128))
  ]))
}
}

})